import { CommonModule } from '@angular/common'
import { Component, Inject, OnInit } from '@angular/core'
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog'
import { Router, RouterModule } from '@angular/router'
import { Store } from '@ngrx/store'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { AppState } from 'src/app/ngrx/states'
import { email, signup } from 'src/app/ngrx/store/actions'
import { AuthUserService } from 'src/app/service/auth/auth-user.service'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'
import { Media, UserLegalInfo } from 'src/app/shared/enums/enums'
import { MyErrorStateMatcher } from 'src/app/shared/models/matcher'
import { DdcButtonROneComponent } from '../../shared/ddc/ddc-button-r-one/ddc-button-r-one.component'
import { DdcButtonSOneComponent } from '../../shared/ddc/ddc-button-s-one/ddc-button-s-one.component'
import { DdcTextGradientComponent } from '../../shared/ddc/ddc-text-gradient/ddc-text-gradient.component'
import { CanvasPlaceholderComponent } from '../ddc-canvas/ddc-canvas-diagram/canvas-placeholder/canvas-placeholder.component'

@Component({
  selector: 'ddc-signup',
  templateUrl: './ddc-signup.component.html',
  styleUrls: ['./ddc-signup.component.scss'],
  imports: [
    AngularMaterialsModules,
    CommonModule,
    RouterModule,
    DdcTextGradientComponent,
    DdcButtonSOneComponent,
    DdcButtonROneComponent,
    ReactiveFormsModule,
    CanvasPlaceholderComponent,
  ],
})
export class DdcSignupComponent implements OnInit {
  _isSignUpBtnLoading = false
  _submitBtnText = 'Agree & Sign Up'
  _hide = true
  _sigUpError: string = ''
  _minlength = 2
  _maxlength = 50
  _passwordRegex = '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[-#_+]).{8,}'
  _usernameRegex = '^[a-z0-9_.]+$'

  _assets = Media.MEDIA
  public _slides = [
    { title: 't1', src: this._assets + '/carousel_1.png' },
    { title: 't1', src: this._assets + '/carousel_2.png' },
    { title: 't1', src: this._assets + '/carousel_3.png' },
    // { title: "t2", src: "https://miro.medium.com/max/720/0*-ATQ3-hGyZxfZqmo" },
    // { title: "t3", src: "https://miro.medium.com/max/720/0*-ATQ3-hGyZxfZqmo" },
    // { title: "t1", src: "https://miro.medium.com/max/720/0*-ATQ3-hGyZxfZqmo" },
    // { title: "t2", src: "http://www.myenglishlanguage.com/wp-content/uploads/2018/06/dictionary.jpg" },
    // { title: "t3", src: "https://www.newstatesman.com/wp-content/uploads/sites/2/2022/06/202226-OED-960x1280.jpg" },
    // { title: "t4", src: "https://snworksceo.imgix.net/bdh/000ca51c-c12e-4146-a200-4a139f1decd1.sized-1000x1000.jpg?w=1000" },
    // { title: "t4", src: "https://snworksceo.imgix.net/bdh/000ca51c-c12e-4146-a200-4a139f1decd1.sized-1000x1000.jpg?w=1000" },
  ]

  _form = new FormGroup({
    _username: new FormControl('', [
      Validators.required,
      Validators.pattern(this._usernameRegex),
      Validators.minLength(this._minlength),
      Validators.maxLength(this._maxlength),
    ]),

    _firstname: new FormControl('', [Validators.required, Validators.maxLength(this._maxlength)]),

    _lastname: new FormControl('', [Validators.required, Validators.maxLength(this._maxlength)]),

    _email: new FormControl('', [
      Validators.required,
      Validators.email,
      Validators.minLength(this._minlength),
      Validators.maxLength(this._maxlength),
    ]),

    _password: new FormControl('', [
      Validators.required,
      Validators.maxLength(50),
      Validators.pattern(this._passwordRegex),
    ]),
  })

  // emailFormControl = new FormControl('', [Validators.required, Validators.email])
  _matcher = new MyErrorStateMatcher()

  constructor(
    private logger: DdcLoggerService,
    private store: Store<AppState>,
    public dialog: MatDialog,
    private authService: AuthUserService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.store.dispatch(signup())
  }

  signUp(): void {
    this.logger.info('DdcSignupComponent: signUp()')
    if (!this._form.valid) return

    this._isSignUpBtnLoading = true
    this._submitBtnText = 'Setting things up ...'

    this.authService.signUp(this._form.value).subscribe((res: any) => {
      if (!res.success) {
        this.logger.error('DdcSignupComponent | signUp | res:', res)
        this._sigUpError = res.message
        this._form.setErrors({
          invalidSignup: true,
        })
        this._isSignUpBtnLoading = false
        this._submitBtnText = 'Agree & Sign Up'
      } else {
        this._submitBtnText = 'Forwarding to Verification...'

        this.store.dispatch(email({ value: this._form.value._email }))

        setTimeout(() => {
          this.router.navigate(['/verification'])
          this._isSignUpBtnLoading = false
          this._submitBtnText = 'Agree & Sign Up'
        }, 2000) // two seconds
      }
    })
  }

  openTermsAndCondsDialog(infoType: string): void {
    this.logger.info('openTermsAndCondsDialog')

    this.dialog.open(DialogUserLegalInfos, {
      data: {
        type: infoType,
      },
    })
  }

  get firstname(): any {
    return this._form.get('_firstname')
  }
  get lastname(): any {
    return this._form.get('_lastname')
  }
  get username(): any {
    return this._form.get('_username')
  }
  get email(): any {
    return this._form.get('_email')
  }
  get password(): any {
    return this._form.get('_password')
  }
}

@Component({
  selector: 'user-legal-infos-dialog',
  templateUrl: '../../shared/dialogs/user-legal-infos-dialog.html',
  imports: [AngularMaterialsModules, CommonModule, RouterModule],
})
export class DialogUserLegalInfos {
  constructor(
    private logger: DdcLoggerService,
    public dialogRef: MatDialogRef<DialogUserLegalInfos>,
    public auth_user: AuthUserService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data.type == 'termsAndConds') {
      this._title = 'Terms and Conditions'
      this._text = UserLegalInfo.TERMS_AND_CONDS
    } else if (data.type == 'privacyPolicy') {
      this._title = 'Privacy Policy'
      this._text = UserLegalInfo.PRIVACY_POLICY
    } else if (data.type == 'cookiePolicy') {
      this._title = 'Cookie Policy'
      this._text = UserLegalInfo.COOKIE_POLICY
    } else this._title = 'Desired Text Here...'
  }

  _title: string = 'Desired _title Here...'
  _text: string = 'Desired _text Here...'
  _lastUpdate: string = UserLegalInfo.LAST_UPDATED

  clickedOK(): void {
    this.logger.info('DialogUserLegalInfos clickedOK()')

    this.auth_user.sign_out().subscribe((res: any) => {
      if (res.message && res.message == 'Logged out successfully') {
        this.router.navigate(['/login'])
        this.dialogRef.close()
      }
    })
  }
}
